export default {
	"messageTemplate": {
		"templateCode": "รหัสเทมเพลต",
		"templateName": "ชื่อเทมเพลต",
		"messageType": "ประเภทข้อความ",
		"templateContent": "ข้อมูลเนื้อหาเทมเพลต",
		"version": "เวอร์ชัน",
		"tabpanleName": "ข้อมูลเทมเพลต",
		"sms": "ข้อความ SMS",
		"emailTitle": "หัวข้อจดหมาย",
		"wechatMsg": "ข่าวกลุ่มองค์กรวีแชท",
		"dd": "ดิงดิง",
		"message": "ข้อมูล",
		"delelteWarning": "ท่านแน่ใจว่าจะลบเทมเพลตนี้หรือไม่"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/messageTemplate/messageTemplate.js